import { z } from "zod"

export const optionSchema = z.object({
  label: z.custom<string | JSX.Element>(),
  value: z.string()
}, { message: 'Campo obrigatório' })